import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import RbacAuditChangeRow from './RbacAuditChangeRow'
import RbacAuditAppUserAssignments from './RbacAuditAppUserAssignments'
import { buildAuditDetail } from './rbacAuditHistoryHelpers'
import {
  auditDetailLinkSx,
  auditExpandedItemSx,
  auditExpandedPanelSx,
  auditFieldLabelSx,
  auditMutedTextSx,
  auditPrimaryTextSx,
  auditStrikeTextSx,
  auditSummaryTextSx,
  auditSystemTextSx
} from './rbacAuditHistoryConstants'

function DescriptionChange({ change }) {
  return (
    <Box>
      <Typography sx={auditFieldLabelSx}>{change.fieldLabel}:</Typography>
      {change.before ? (
        <Typography sx={{ ...auditStrikeTextSx, mt: 0.5, lineHeight: 1.5 }}>
          {change.before}
        </Typography>
      ) : null}
      {change.after ? (
        <Typography sx={{ ...auditPrimaryTextSx, mt: 0.5, lineHeight: 1.5 }}>
          {change.after}
        </Typography>
      ) : null}
    </Box>
  )
}

export default function RbacAuditDetailCell({ entry, context, permissionLabelMap = {} }) {
  const [expanded, setExpanded] = useState(false)
  const detail = buildAuditDetail(entry, context, permissionLabelMap)

  if (detail.type === 'app-user-assignments') {
    return <RbacAuditAppUserAssignments detail={detail} />
  }

  if (detail.type === 'changes') {
    return (
      <Box>
        {detail.changes.map((change, index) => (
          <RbacAuditChangeRow key={`${change.fieldLabel}-${index}`} change={change} />
        ))}
      </Box>
    )
  }

  if (detail.type === 'description') {
    return <DescriptionChange change={detail.change} />
  }

  if (detail.type === 'accordion') {
    return (
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Typography sx={auditSummaryTextSx}>{detail.summary}</Typography>
          <Box
            component="button"
            type="button"
            sx={auditDetailLinkSx}
            onClick={() => setExpanded((prev) => !prev)}
          >
            {expanded ? 'ver menos' : 'ver más ...'}
          </Box>
        </Box>
        {expanded ? (
          <Box sx={auditExpandedPanelSx}>
            {detail.changes.map((change, index) => (
              <Box key={`${change.fieldLabel}-${index}`} sx={auditExpandedItemSx}>
                <RbacAuditChangeRow change={change} />
              </Box>
            ))}
          </Box>
        ) : null}
      </Box>
    )
  }

  if (detail.type === 'system') {
    return <Typography sx={auditSystemTextSx}>{detail.summary || '—'}</Typography>
  }

  return <Typography sx={auditMutedTextSx}>{detail.summary || '—'}</Typography>
}
